import { ArrowPosition } from "../../StickyNote";
import { AnchorIds, FeedbackTourVariations, TourIds, TourSignal, TourStep } from "../../TourTypes";
import InlineSVG from "react-inlinesvg";
import {
  FeedbackTourChooseTypeContent,
  FeedbackTourIntroContent,
  FeedbackTourPasteContent,
  FeedbackTourPrefilledContent,
  FeedbackTourRunFeedbackContent,
  FeedbackTourWrapUpContent,
} from "./content";

const FeedbackTourOpenTypeContent = () => (
  <>
    Click{" "}
    <InlineSVG
      src="/assets/down-chevron.svg"
      aria-label="down chevron"
      className="inline-block align-middle [&_path]:fill-[var(--primary-cta)] [&_path]:stroke-[var(--primary-cta)]"
      style={{ width: 12, height: 12 }}
    />{" "}
    to select the type of Feedback you'd like.
  </>
);

export const getFeedbackTour = (variation: FeedbackTourVariations = FeedbackTourVariations.NOT_IMPORTED) => {
  const isImported = variation === FeedbackTourVariations.IMPORTED;

  const steps: TourStep[] = [
    {
      id: "1",
      stickies: [
        {
          content: "👋 Hello! Ready to learn how to use Sudowrite? Click this project to get started.",
          offsetX: 200,
          offsetY: -40,
          anchorId: AnchorIds.PROJECT_CARD,
          rotation: 3,
          arrowPosition: ArrowPosition.BottomLeft,
        },
      ],
      listeningFor: [TourSignal.PROJECT_CARD_CLICKED],
    },
    {
      id: "2",
      stickies: [
        {
          content: <FeedbackTourIntroContent />,
          offsetX: 0,
          offsetY: 35,
          anchorId: AnchorIds.FEEDBACK_BUTTON,
          rotation: -2,
          arrowPosition: ArrowPosition.Top,
        },
        {
          content: "Setting up your project...",
          offsetX: 340,
          offsetY: 0,
          anchorId: AnchorIds.EDITOR,
          renderIfAnchorMissing: AnchorIds.FEEDBACK_BUTTON,
          rotation: 2,
        },
      ],
      listeningFor: [TourSignal.STICKY_NEXT],
    },
    {
      id: "3",
      stickies: [
        {
          content: isImported ? <FeedbackTourPrefilledContent /> : <FeedbackTourPasteContent />,
          offsetX: 340,
          offsetY: 40,
          anchorId: AnchorIds.EDITOR,
          rotation: 3,
          arrowPosition: ArrowPosition.BottomLeft,
        },
      ],
      listeningFor: [TourSignal.STICKY_NEXT],
    },
    {
      id: "4",
      stickies: [
        {
          content: <FeedbackTourOpenTypeContent />,
          offsetX: -100,
          offsetY: 35,
          anchorId: AnchorIds.FEEDBACK_CHEVRON,
          rotation: -3,
          arrowPosition: ArrowPosition.Top,
        },
      ],
      listeningFor: [TourSignal.FEEDBACK_CHEVRON_CLICKED],
    },
    {
      id: "5",
      stickies: [
        {
          content: <FeedbackTourChooseTypeContent />,
          offsetX: 370,
          offsetY: 30,
          anchorId: AnchorIds.FEEDBACK_TYPE_DROPDOWN,
          rotation: 2,
          arrowPosition: ArrowPosition.BottomLeft,
        },
        {
          content: <FeedbackTourOpenTypeContent />,
          offsetX: -100,
          offsetY: 35,
          anchorId: AnchorIds.FEEDBACK_CHEVRON,
          renderIfAnchorMissing: AnchorIds.FEEDBACK_TYPE_DROPDOWN,
          rotation: -3,
          arrowPosition: ArrowPosition.Top,
        },
      ],
      listeningFor: [TourSignal.STICKY_NEXT],
    },
    {
      id: "6",
      stickies: [
        {
          content: <FeedbackTourRunFeedbackContent />,
          offsetX: 50,
          offsetY: 35,
          anchorId: AnchorIds.FEEDBACK_BUTTON,
          rotation: -3,
          arrowPosition: ArrowPosition.TopLeft,
        },
      ],
      listeningFor: [TourSignal.FEEDBACK_BUTTON_CLICKED],
    },
    {
      id: "6.1",
      stickies: [
        {
          content: <p>Feel free to get up and stretch while Sudowrite leaves you comments.</p>,
          offsetX: 50,
          offsetY: 35,
          anchorId: AnchorIds.FEEDBACK_BUTTON,
          rotation: -2,
        },
      ],
      listeningFor: [TourSignal.FEEDBACK_COMPLETED],
      listeningForFailure: [TourSignal.FEEDBACK_FAILED, TourSignal.FEEDBACK_CANCELLED],
    },
    {
      id: "7",
      stickies: [
        {
          content: <FeedbackTourWrapUpContent />,
          offsetX: -620,
          offsetY: 322,
          anchorId: AnchorIds.RIGHT_BAR_TOGGLE,
          rotation: 3,
        },
        {
          content: (
            <p>
              🎉 Sweet! You can always tag <strong>@Sudowrite</strong> in your replies to start a discussion.
            </p>
          ),
          offsetX: -720,
          offsetY: 92,
          anchorId: AnchorIds.RIGHT_BAR_TOGGLE,
          rotation: -2,
        },
      ],
      listeningFor: [TourSignal.STICKY_NEXT],
    },
  ];

  return {
    id: TourIds.FEEDBACK,
    variation,
    steps,
  };
};
